import * as tslib_1 from "tslib";
import { DateTimeFormats_$type } from "./DateTimeFormats";
import { EditorType_$type } from "./EditorType";
import { IgrColumn } from "./igr-column";
import { DateTimeColumn } from "./DateTimeColumn";
import { ensureEnum } from "igniteui-react-core";
/**
 * A column for displaying date/time values.
*/
var IgrDateTimeColumn = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrDateTimeColumn, _super);
    function IgrDateTimeColumn(props) {
        return _super.call(this, props) || this;
    }
    IgrDateTimeColumn.prototype.createImplementation = function () {
        return new DateTimeColumn();
    };
    Object.defineProperty(IgrDateTimeColumn.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "dateTimeFormat", {
        /**
         * Gets or sets the date time format to use for this column. If FormatString is specificied this value is ignored.
        */
        get: function () {
            return this.i.jj;
        },
        set: function (v) {
            this.i.jj = ensureEnum(DateTimeFormats_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "formatOverride", {
        /**
         * Gets or sets the INTL DateTimeFormat object to use for formatting the date values.
        */
        get: function () {
            return this.i.jo;
        },
        set: function (v) {
            this.i.jo = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "editorType", {
        /**
         * Gets or sets the editor type used for editing cells in this column.
        */
        get: function () {
            return this.i.jk;
        },
        set: function (v) {
            this.i.jk = ensureEnum(EditorType_$type, v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "editorDataSource", {
        /**
         * Gets or sets the ComboBox data source.
        */
        get: function () {
            return this.i.jn;
        },
        set: function (v) {
            this.i.jn = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "editorTextField", {
        /**
         * Gets or sets the ComboBox text field.
        */
        get: function () {
            return this.i.jr;
        },
        set: function (v) {
            this.i.jr = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDateTimeColumn.prototype, "editorValueField", {
        /**
         * Gets or sets the ComboBox value field.
        */
        get: function () {
            return this.i.jg;
        },
        set: function (v) {
            this.i.jg = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrDateTimeColumn;
}(IgrColumn));
export { IgrDateTimeColumn };
//# sourceMappingURL=igr-date-time-column.js.map
